<script>
export default {
  name: "sellOrderRulesForm",
  props: {
    cityData: {
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      disabled: true,
      form: {
        serviceFeeStatus: 1,
        serviceFee: "",
        status: 2,
        commissionRule: [{ minFee: "", maxFee: "", type: 1, value: "" }],
      },
      loading: false,
    };
  },
  computed: {
    rules() {
      return {
        serviceFee: [
          {
            required: this.form.serviceFeeStatus === 1,
            message: "请输入数字",
            trigger: "blur",
          },
        ],
      };
    },
    routeName() {
      return this.$route.name;
    },

  },
  watch: {
    cityData: {
      handler(newval) {
        this.initFn();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    initFn() {
      if (!this.cityData.organizationId) { return }
      const url = "/api/v1/manage/hitchRide/commissionRule/info";
      this.$axios
        .get(url, {
          organizationId: this.cityData.organizationId,
        })
        .then(({ code, data }) => {
          if (code === 1 && data) {
            this.form = {
              ...data,
              commissionRule: data.commissionRule
                ? JSON.parse(data.commissionRule)
                : [{ minFee: "", maxFee: "", type: 1, value: "" }],
            };
          }
        });
    },

    submitForm() {
      this.$refs.form.validate().then(async (valid) => {
        this.loading = true;
        const url = "/api/v1/manage/hitchRide/commissionRule";
        const data = await this.$axios.post(url, {
          ...this.form,
          commissionRule: JSON.stringify(this.form.commissionRule),
        });
        this.loading = false;
        if (data.code === 1) {
          this.$message.success("保存成功");
          this.disabled = true;
        }
      });
    },
    cancelForm() {
      this.disabled = true;
      this.initFn();
    },
    addClick() {
      const prevMaxPee = this.form.commissionRule.length
        ? this.form.commissionRule[this.form.commissionRule.length - 1].maxFee
        : 0;
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.form.commissionRule.push({
            type: 1,
            maxFee: "",
            minFee: prevMaxPee,
            value: "",
          });
        } else {
          return false;
        }
      });
    },
    removeClick(index) {
      this.form.commissionRule.splice(index, 1);
      this.$nextTick(() => {
        if (this.form.commissionRule[index]) {
          this.form.commissionRule[index].minFee = this.form.commissionRule[index - 1].maxFee
        }
      });
    },
    maxInput(e, idx) {
      if (this.form.commissionRule[idx + 1]) {
        this.form.commissionRule[idx + 1].minFee = e
      }
    },
    /**
     * 验证器
     */
    validateminFee(rule, value, callback) {
      if (this.disabled || !value) {
        callback()
        return;
      }
      let arr = rule.fullField.split(".");
      let i = Number(arr[1]);
      let itemMin = this.form.commissionRule[i].minFee;
      let itemMax = this.form.commissionRule[i].maxFee;
      let prevItem = i > 0 ? this.form.commissionRule[i - 1].maxFee : null;
      if (!itemMax) {
        callback();
      } else if (i > 0 && prevItem && itemMin < prevItem) {
        callback(new Error("请大于上一项规则的金额"));
      } else if (i < 5 && itemMin > itemMax) {
        callback(new Error("请小于结束金额"));
      } else {
        callback();
      }
    },
    validatemaxFee(rule, value, callback) {
      if (this.disabled || !value) {
        callback()
        return;
      }
      let arr = rule.fullField.split(".");
      let i = Number(arr[1]);
      let itemMin = this.form.commissionRule[i].minFee;
      let itemMax = this.form.commissionRule[i].maxFee;
      let nextItem = this.form.commissionRule[i + 1]
        ? this.form.commissionRule[i + 1].minFee
        : null;
      if (itemMin) {
        this.$refs.form.validateField(`commissionRule.${i}.minFee`);
      }
      if (itemMax <= itemMin) {
        callback(new Error("请大于开始金额"));
      } else if (nextItem && itemMax > nextItem) {
        callback(new Error("请小于下一项规则的开始金额"));
      } else {
        callback();
      }
    },
    blurValue(e, item) {
      let min, max;
      if (item.type == 1) {
        min = 0.01;
        max = 999;
      } else {
        min = 1;
        max = 100;
      }
      let value = item.value;
      if (value > max) {
        value = max;
      }
      if (value < min) {
        value = min;
      }

      item.value = value
    },
    changeValue(e, item) {
      let min, max;
      if (item.type == 1) {
        min = 0.01;
        max = 999;
      } else {
        min = 1;
        max = 100;
      }
      let value = e;
      // 移除多余的 "."
      value = value.replace(/(\.\d*?)\./g, '$1');
      // 限制小数位数不超过2位
      if (value.includes('.')) {
        const parts = value.split('.');
        if (parts[1].length > 2) {
          value = `${parts[0]}.${parts[1].substring(0, 2)}`;
        }
      }
      // 防止输入非数字字符
      value = item.type == 1 ? value.replace(/[^0-9.]/g, '') : value.replace(/[^0-9]/g, '');
      if (value > max) {
        value = max;
      }

      item.value = value
    },
    changeType(item) {
      item.value = ""
    },
    inputValue(index) {
      this.$refs.form.validateField(`commissionRule.${index}.maxFee`);
    }
  },
};
</script>

<template>
  <div class="sellOrderRulesForm" style="width: 840px;">
    <div class="flex-between">
      <div class="formTitle">抽成规则</div>
      <template v-if="btnPreFn(routeName + '_edit', false)">
        <el-button type="primary" v-if="disabled" @click="disabled = false">编辑</el-button>
        <div v-else>
          <el-button @click="cancelForm">取消</el-button>
          <el-button type="primary" @click="submitForm" :loading="loading">保存</el-button>
        </div>
      </template>
    </div>
    <el-form :model="form" ref="form" :rules="rules" :disabled="disabled" size="small">
      <el-form-item style="margin-bottom: 15px">
        <div class="flex-start">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="2"></el-switch>
          <span class="util-remark tips">如关闭，则订单完成后平台不参与该笔订单的抽成</span>
        </div>
      </el-form-item>
      <el-form-item>
        <div v-for="(item, index) in form.commissionRule" :key="index" class="flex" style="margin-bottom: 16px;">
            <el-form-item 
              label="" 
              :prop="'commissionRule.' + index + '.minFee'" 
              :rules="[
                { required: form.status == 1, message: '请输入数字' },
                { validator: validateminFee, trigger: 'change' },
              ]"
              style="width: 258px; flex-shrink: 0;"
            >
              <el-input v-model="item.minFee" v-input-filter="{ min: 0, max: 999999, precision: 2 }" :controls="false"
                :disabled="index > 0" @input="inputValue(index)">
                <template slot="prepend">当订单金额≥</template>
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="" :prop="'commissionRule.' + index + '.maxFee'" :rules="[
              { required: form.status == 1, message: '请输入数字' },
              { validator: validatemaxFee, trigger: 'change' },
            ]" style="width: 258px; margin-left: 8px; flex-shrink: 0;">
              <el-input v-model="item.maxFee" v-input-filter="{ min: 0, max: 999999, precision: 2 }" :controls="false"
                @input="maxInput($event, index)">
                <template slot="append">元，按</template>
                <template slot="prepend">且＜</template>
              </el-input>
            </el-form-item>
            <el-form-item label="" :prop="'commissionRule.' + index + '.value'" style="width: 100px; margin-left: 8px; flex-shrink: 0;">
              <el-select v-model="item.type" @change="changeType(item)">
                <el-option label="固定金额" :value="1"></el-option>
                <el-option label="金额比例" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" :prop="'commissionRule.' + index + '.value'"
              :rules="[{ required: form.status == 1, message: '请输入数字' }]" style="width: 200px; margin-left: 8px; flex-shrink: 0;">
              <el-input :value="item.value" @input="changeValue($event, item)" @blur="blurValue($event, item)">
                <template slot="prepend">抽成</template>
                <template slot="append">{{ item.type == 1 ? "元" : "%" }}</template>
              </el-input>
            </el-form-item>
            <span style="width: 20px; margin-left: 8px;">
              <i v-if="index !== 0 && !disabled" style="color: red" class="iconfont icon-delete"
                @click="removeClick(index)"></i>
            </span>
        </div>
      </el-form-item>

      <el-button size="large" style="width: 100%; border-style: dashed; color: #606266;"
        v-if="form.commissionRule.length < 5 && !disabled" @click="addClick">
        添加抽成规则（还可添加{{ 5 - form.commissionRule.length }}个）
      </el-button>

      <div class="formTitle">信息费</div>

      <el-form-item label="" style="margin-bottom: 0">
        <div class="flex-start" style="margin-bottom: 15px">
          <el-switch v-model="form.serviceFeeStatus" :active-value="1" :inactive-value="2" size="small"></el-switch>
          <span class="util-remark" style="padding-left: 10px">如关闭，则当前机构不对已完成的顺风车订单收取信息费</span>
        </div>
      </el-form-item>
      <el-form-item label="" prop="serviceFee" style="margin-bottom: 15px">
        <div class="flex-start">
          <span style="padding-right: 10px">每单固定收取</span>
          <el-input style="width: 162px" v-model="form.serviceFee"
            v-input-filter="{ min: 0.1, max: 9.9, precision: 2 }"></el-input>
          <span style="padding: 0 10px">元信息费</span>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<style scoped lang="less">
.sellOrderRulesForm {
  .tips {
    margin-left: 10px;
  }

  /deep/ .el-form-item {
    margin-bottom: 0;
  }

  /deep/ .el-input-group__append,
  .el-input-group__prepend {
    background-color: #F5F7FA !important;
  }
}
</style>